import { ref } from 'vue'
import { user } from '@/store/user'

const Modales = ref({
  contact: false,
  contact_guest: false,
  simulateur_ifc: false,
  validation_salarie_modale: false,
});

const ModalesManager = {
  open(modale){
    this.close();
    Modales.value[modale] = true
  },
  close(cover){
    const _modales = Modales.value;
    for (let modaleName of Object.keys(_modales)){
      _modales[modaleName] = false
    }
    Modales.value = _modales;

  }
}

export {ModalesManager, Modales }

